import { useTranslation } from "react-i18next";

import { Badge } from "@unified-checkout/design-system";
import { Check } from "@unified-checkout/design-system/icons/index";

import styles from "./stepper.module.scss";


export const Stepper = ({
  step,
  totalNumberOfSteps,
  featureName,
  desc
}: {
  step: number,
  totalNumberOfSteps: number,
  featureName: string,
  desc?: string
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles["stepper"]}>

      <div className={styles["stepper__step"]}>
        {step}

        <div className={styles["stepper__step__check-icon"]}>
          {Check}
        </div>
      </div>

      <div className={styles["stepper__text-box"]}>

        <div className={styles["stepper__text-box__step"]}>
          {t('innerLayout.dashboardGuide.steps.stepXOfY', { x: step, y: totalNumberOfSteps })}
        </div>

        {
          desc &&
          <div className={styles["stepper__text-box__desc"]}>
            {desc}
          </div>
        }
      </div>

      <Badge
        size="md"
        color="green"
        text={featureName}
      />
    </div>
  )
}
